import {
  XUtils
} from '../common/globals'

export * from './error'
export * from './passport'
export * from './mqtt-room'

const CONST = XUtils.getConst()

const ROOM_ID = XUtils.q2o(location.search.slice(1)).roomId || 31
const {
  CORP,
  CORP_XS,
  ENV_MODE,
  HOST_BBS,
  HOST_API,
  HOST_WEB,
  HOST_STATIC,
  HOST_PASSPORT
} = CONST

export {
  CORP,
  CORP_XS,
  ENV_MODE,
  HOST_BBS,
  HOST_API,
  HOST_WEB,
  HOST_STATIC,
  HOST_PASSPORT,

  ROOM_ID
}

export const ERR_REP_NOT_PLAIN = 40000
export const ERR_REP_NOT_lIST = 40001

// 订单
export const ORDER_SCENE_XS_SHOP = 10
export const ORDER_SCENE_XS_BIZ = 11

// 时间
export const MS_SECOND = 1000
export const MS_MINUTE = 60000
export const MS_HOUR = 60 * MS_MINUTE
export const MS_DAY = 24 * MS_HOUR

//nowTimeSection
//初始化时候，当前时间所处的阶段：0 ：0.00-9.15之前 1：9.15-10.00 2：10.00-24.00
export const NOW_TIME_STATUS_NONE = 0 
export const NOW_TIME_STATUS_ONE = 1 
export const NOW_TIME_STATUS_TWO = 2 

//获取详情的时间段状态 1: 15:30-次15:00 2: 15:00-15:30
export const BAT_DETAIL_TIME_ONE = 1
export const BAT_DETAIL_TIME_TWO = 2
